module.exports = "/_next/static/images/UpesacmTech-44d657a25da29573888cc3a59c2d319e.jpg";